import * as React from "react"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"

import Footer from "../components/footer.js"
import Header from "../components/header.js"

import BankHeroImage from "../images/portuguese-bank-account-setup.svg"
import ArrowPink from "../images/arrow-pink.png"
import IconVideoCall from "../images/icon-video-call.svg"
import IconRepresentative from "../images/icon-millennium-representative.svg"
import IconChecklist from "../images/icon-bank-checklist.svg"
import PatternPink from "../images/pattern-pink.png"
import IconPassport from "../images/icon-passport.svg"
import IconLocation from "../images/icon-location-pin.svg"
import IconEmployment from "../images/icon-business-case.svg"
import IconNif from "../images/icon-nif-document.svg"
import Number1Pink from "../images/number-1-pink.svg"
import Number2Pink from "../images/number-2-pink.svg"
import Number3Pink from "../images/number-3-pink.svg"
import Number4Pink from "../images/number-4-pink.svg"
import Number5Pink from "../images/number-5-pink.svg"
import Favicon from "../images/bordr-favicon.png"
import SocialShare from "../images/bordr-logo-social.jpg"

const bankPrice = "$350";

const bankAccountPage = () => {
  return (
    <main>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="shortcut icon" type="image/png" href={Favicon}/>
        <meta name="author" content="Bordr Team"></meta>
        <meta name="description" content="Open a Portuguese bank account from anywhere in the world. Set up and fund your account today."></meta>
        {/* Open graph data */}
        <meta property="og:title" content="Bordr - Portugal Bank Account Setup" />
        <meta property="og:url" content="https://bordr.io/bank" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="Open a Portuguese bank account from anywhere in the world. Set up and fund your account today." />
        <meta property="og:image" content={SocialShare} />
        <meta property="fb:app_id" content="409286673692377" />
        <title>Bordr - Portugal Bank Account Setup</title>
        {/* iubenda popups */}
        <script type="text/javascript" async defer>{'(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);'}</script>
        {/* helpscout beacon */}
        <script type="text/javascript" async defer>{'!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});'}</script>
        <script type="text/javascript" async defer>{'window.Beacon("init", "1bc22ba4-9a9a-4d05-a0b0-5e10bc8614dc")'}</script>
      </Helmet>
      <section className="bg-yellow-500">
        <div className="max-w-screen-xl mx-auto px-6 py-3">
          <p className="text-white text-center text-lg emoji-icon"><span role="img" aria-label="stopwatch">⏱️</span>&nbsp;&nbsp;Our current bank turnaround time is 2-3 weeks&nbsp;&nbsp;<span role="img" aria-label="stopwatch">⏱️</span></p>
        </div>  
      </section>
      {/*-- hero banner --*/}
      <section className="bg-pink-50 flex flex-col">
        <Header />
        {/*-- grid --*/}
        <div className="max-w-screen-xl mx-auto my-12 px-6 flex flex-col md:flex-row items-center md:items-end">
          {/*-- hero text --*/}
          <div className="md:mr-8 text-center md:text-left">
            <h1 className="text-4xl md:text-5xl font-bold">Open a Portuguese bank account from anywhere in the world</h1>
            <h3 className="text-xl md:text-2xl mt-3">Set up your bank account today</h3>
            <div className="mt-6 md:mt-8"> 
              <Link to="/checkout-bank/" className="btn-pink">Open an account</Link>
            </div>
          </div>
          {/*-- hero image --*/}
          <div className="w-4/5 md:w-3/4 pt-6 md:pt-0">
            <img src={BankHeroImage} alt="woman carrying bank card"/>
          </div>              
        </div>  
      </section>
      {/*-- angle --*/}
      <section className="bg-pink-angle bg-no-repeat bg-cover h-10-vw">
        <div className="max-w-screen-xl mx-auto px-6">
          <img src={ArrowPink} alt="pink arrow" className="hidden md:inline-block -rotate-2 h-24 lg:h-32 ml-2"/>
        </div>
      </section>
      {/*-- value props --*/}
      <section className="xl:-mt-8 2xl:-mt-14 pb-16">
        {/*-- 3 column layout --*/}
        <div className="max-w-screen-xl mx-auto mt-8 px-6">
          {/*-- heading text --*/}
          <div className="md:w-3/5">
            <h2 className="text-3xl font-bold">Need a Portuguese bank account for your visa application? We’ve got you covered.</h2>
            <h4 className="text-xl mt-3">We can help you open a bank account while you're still outside the country.</h4>
          </div>
          {/*-- 3 points --*/}
          <div className="flex flex-col md:flex-row mt-10 md:mt-8">
            <div className="justify-start mb-10 md:mb-8 md:mr-10 md:w-1/3">
              <img src={IconVideoCall} alt="video call on laptop" className="h-20 mb-6"/>
              <h5 className="uppercase text-lg font-bold tracking-wider leading-tight">No Apostille Required</h5>
              <p className="text-base mt-2">Turn weeks into minutes. Skip the Apostille by getting your signature recognized by a law firm in Portugal.</p>
            </div>
            <div className="justify-start mb-10 md:mb-8 md:mr-10 md:w-1/3">
              <img src={IconRepresentative} alt="watch icon" className="h-20 mb-4"/>
              <h5 className="uppercase text-lg font-bold tracking-wider leading-tight">White Glove Service</h5>
              <p className="text-base mt-1">Your account comes with a private bank manager who will assist you in opening your bank account and act as your point of contact with the bank.</p>
            </div>
            <div className="justify-start mb-10 md:mb-8 md:mr-10 md:w-1/3">
              <img src={IconChecklist} alt="chat bubble on phone icon" className="h-20 mb-4"/>
              <h5 className="uppercase text-lg font-bold tracking-wider leading-tight">Easy and Convenient</h5>
              <p className="text-base mt-1">Let us do the heavy lifting. We’ve streamlined the process of opening a bank account in Portugal to 5 easy steps.</p>
            </div>
          </div>
          {/*-- button --*/}
          <div className="mt-4 mb-3"> 
            <Link to="/checkout-bank/" className="btn-pink">Open an account</Link>
          </div>
        </div>
      </section>                        
      {/*-- about the bank --*/}
      <section className="bg-gray-50 py-16">
        <div className="max-w-screen-xl mx-auto px-6 flex flex-col items-center">
          {/*-- heading text --*/}
          <div className="w-full md:w-3/4 text-center justify-start">
            <h2 className="text-3xl font-bold">About the Account</h2>
            <h4 className="text-xl mt-3 mb-8">We work with one of the largest private banks in Portugal. With your account, you'll have access to hundreds of branches and ATMs throughout the country.</h4>
          </div>
          {/*-- 3 steps --*/}
          <div className="grid grid-cols-3 gap-x-4 gap-y-10">
            <div className="col-span-3 md:col-span-1">
              <h3 className="uppercase text-lg font-bold tracking-wider">Type of Account</h3>
            </div>
            <div className="col-span-3 md:col-span-2">
              <p className="text-base -mt-8 md:mt-0">
                Can be individual or joint
              </p>
            </div>
            <div className="col-span-3 md:col-span-1">
              <h3 className="uppercase text-lg font-bold tracking-wider">What it includes</h3>
            </div>
            <div className="col-span-3 md:col-span-2">
              <p className="text-base -mt-8 md:mt-0">
                <ul className="list-disc list-inside">
                  <li>A private bank manager</li>
                  <li>Online banking access</li>
                  <li>2 debit cards</li>
                  <li>2 credit cards</li>
                  <li>Free euro transfers to countries to SEPA member states (EU, UK, and 8 more)</li>
                </ul>
              </p>
            </div>
            <div className="col-span-3 md:col-span-1">
              <h3 className="uppercase text-lg font-bold tracking-wider">Minimum Deposit</h3>
            </div>
            <div className="col-span-3 md:col-span-2">
              <p className="text-base -mt-8 md:mt-0">
                The minimum amount required to open an account is 250€.
              </p>
            </div>
            <div className="col-span-3 md:col-span-1">
              <h3 className="uppercase text-lg font-bold tracking-wider">Fees</h3>
            </div>
            <div className="col-span-3 md:col-span-2">
              <p className="text-base -mt-8 md:mt-0">
              15 euros/month maximum
              </p>
            </div>
          </div>
        </div>
      </section>
      {/*-- requirements --*/}
      <section className="pt-16">
        {/*-- 3 column layout --*/}
        <div className="max-w-screen-xl mx-auto px-6 flex flex-col items-center">
          {/*-- heading text --*/}
          <div className="w-full md:w-3/4 text-center justify-start">
            <h2 className="text-3xl font-bold">Requirements</h2>
            <h4 className="text-xl mt-3 mb-8">Here are 4 things you'll need to get started</h4>
          </div>
          {/*-- 4 things --*/}
          <div className="w-full grid grid-cols-4 gap-x-4 gap-y-8 md:gap-y-0">
            <div className="col-span-2 md:col-span-1 flex flex-col justify-start">
              <img src={IconPassport} alt="passport icon" className="h-16 mb-4"/>
              <p className="text-base mt-1 text-center">Valid passport</p>
            </div>
            <div className="col-span-2 md:col-span-1 flex flex-col justify-start">
              <img src={IconLocation} alt="location icon" className="h-16 mb-4"/>
              <p className="text-base mt-1 text-center">Proof of address in your country of residence</p>
            </div>
            <div className="col-span-2 md:col-span-1 flex flex-col justify-start">
              <img src={IconEmployment} alt="briefcase icon" className="h-16 mb-4"/>
              <p className="text-base mt-1 text-center"><a className="link-pink" href="" data-beacon-article-modal="/60aac4fd13fd125a39b467b2">Proof of employment</a><br/>
                (not needed for retirees)
              </p>
            </div>
            <div className="col-span-2 md:col-span-1 flex flex-col justify-start">
              <img src={IconNif} alt="nif document icon" className="h-16 mb-4"/>
              <p className="text-base mt-1 text-center">Portugal NIF document</p>
            </div>
          </div>
        </div>
      </section>
      {/*-- button --*/}
      <section className="pb-16">   
        <div className="text-center mt-10"> 
          <Link to="/checkout-bank/" className="btn-pink">Open an account</Link>
        </div>
      </section>    
      {/*-- crosses --*/}
      <div className="max-w-screen-xl mx-auto px-6 flex flex-row justify-center">
        <img src={PatternPink} alt="cross pattern" className="hidden md:block w-24"/>
      </div>
      {/*-- how it works --*/}
      <section className="bg-pink-50 py-16 mt-8 md:-mt-10">
        <div className="max-w-screen-xl mx-auto px-6 flex flex-col items-center">
          {/*-- heading text --*/}
          <div className="w-full md:w-3/4 text-center justify-start">
            <h2 className="text-3xl font-bold">How it Works</h2>
          </div>
          {/*-- 3 steps --*/}
          <div className="w-full md:w-1/2 flex flex-col">
            <div className="flex flex-row items-center mt-10">
              <img src={Number1Pink} alt="one" className="h-10 w-6 mr-6"/>
              <div>
                <h3 className="text-lg font-bold">Place your order</h3>
                <p className="text-base">Fill out our online form and complete payment of {bankPrice} USD.</p>
              </div>
            </div>
            <div className="flex flex-row items-center mt-10">
              <img src={Number2Pink} alt="two" className="h-10 w-6 mr-6"/>
              <div>
                <h3 className="text-lg font-bold">Receive bank account opening documents</h3>
                <p className="text-base">Receive your account opening documents via email.</p>
              </div>
            </div>
            <div className="flex flex-row items-center mt-10">
              <img src={Number3Pink} alt="three" className="h-10 w-6 mr-6"/>
              <div>
                <h3 className="text-lg font-bold">Sign your documents</h3>
                <p className="text-base">Get your signatures recognized by a Portuguese law firm.</p>
              </div>
            </div>
            <div className="flex flex-row items-center mt-10">
              <img src={Number4Pink} alt="four" className="h-10 w-6 mr-6"/>
              <div>
                <h3 className="text-lg font-bold">Mail your documents to Portugal</h3>
                <p className="text-base">Gather all of your documents and ship them to Portugal. We will provide you with the mailing address and final checklist of documents that need to be sent.</p>
              </div>
            </div>
            <div className="flex flex-row items-center mt-10">
              <img src={Number5Pink} alt="five" className="h-10 w-6 mr-6"/>
              <div>
                <h3 className="text-lg font-bold">Get access to your new bank account!</h3>
                <p className="text-base">Once your signed documents have been received, your bank manager will open your bank account and provide you with online access.</p>
              </div>
            </div>
          </div>
        </div>
        {/*-- button --*/}
        <div className="text-center text-base mt-10"> 
          <Link to="/checkout-bank/" className="btn-pink">Open an account</Link>
        </div>
      </section>
      {/*-- details --*/}
      <section className="py-16">
        <div className="max-w-screen-xl mx-auto px-6 flex flex-col w-full md:w-3/4 text-center">
          {/*-- heading text --*/}
          <h2 className="text-3xl font-bold">Cost</h2>
          <div>
            <div className="mt-4">
              <p className="text-lg font-bold leading-tight">{bankPrice} USD per account</p>
              <p className="text-base mt-1">
                The account can be for an individual or a joint account with multiple account owners.
                Our fee includes the cost of the signature certification by a law firm in Portugal. You will not need to notarize or apostille any of the account opening documents.
              </p>
            </div>
          </div>
          <h2 className="mt-10 text-3xl font-bold">Timing</h2>
          <div>
            <div className="mt-4">
              <p className="text-lg font-bold leading-tight">How long does it take to open to bank account?</p>
              <p className="text-base mt-1">
              For most people, the average turnaround time to open a bank account is 2-3 weeks.
              </p>
            </div>
          </div>
          {/*-- button --*/}
          <div className="mt-12 mb-3"> 
            <Link to="/checkout-bank/" className="btn-pink">Open an account</Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  )
}

export default bankAccountPage
